<button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
	<button mat-menu-item (click)="toggleFullScreen()">{{isFullScreen ? 'Стандартный вид' : 'На весь экран'}} </button>
	<button mat-menu-item (click)="logout()">Выход</button>
</mat-menu>
